import React, { createContext } from "react";
import { ProjectHalSource } from "@/halSources";

interface IProjectContext{
    contacts?: API.PROJECT.Contract[],
    permissions?: string[],
    project?: ProjectHalSource
}
export const ProjectDetailContext = createContext<IProjectContext>({})